<template v-if="canView(localData)">
	<div>
		<v-list-item>
			<v-list-item-content class="mt-2">
				<v-list-item-title
						v-if="localData.heading"
						class="mb-2 mt-0 text-h6"
						tag="h2"
				>
					{{ localData.heading }}
				</v-list-item-title>
				<v-list-item-subtitle v-if="localData.subheading?.text">
					<v-icon
							v-if="localData.subheading.icon"
							:color="localData.subheading.iconColor || 'grey'"
							:size="localData.subheading.iconSize || 16"
					>
						{{ localData.subheading.icon }}
					</v-icon>
					{{ localData.subheading?.text }}
				</v-list-item-subtitle>
				<a
						v-if="localData.link"
						class="mt-4 pa-0 primary--text text-body-2 text--darken1"
						:href="localData?.link"
						:target="localData.target"
				>
					<v-icon v-if="localData.linkIcon" class="me-1" small>
						{{ localData.linkIcon }}
					</v-icon>
					{{ localData.linkText }}
					<v-icon v-if="localData.target === '_blank'" class="ms-1" small>
						mdi-open-in-new
					</v-icon>
				</a>
				<template v-if="localData.emits" v-for="(emitData, idx) in localData.emits">
					<v-divider class="mb-0 mt-2 opacity-30"></v-divider>
					<a
							v-if="emitData.emit"
							class="mt-4 pa-0 primary--text text-body-2 text--darken1"
							@click.stop.prevent="emitEvent(emitData.emit)"
					>
						<div class="d-flex justify-space-between">
							<div class="d-flex">
								<v-icon
										v-if="emitData.emitIcon"
										class="me-2 ms-1"
										:color="emitData.emitIconColor || null"
										small
								>
									{{ emitData.emitIcon }}
								</v-icon>
								{{ emitData.emitText }}
							</div>
							<v-icon
									v-if="emitData.emitAppendIcon"
									class="mx-1"
									:color="emitData.emitAppendIconColor || null"
									:size="emitData.emitAppendIconSize || 'small'"
							>
								{{ emitData.emitAppendIcon }}
							</v-icon>
						</div>
					</a>
				</template>

			</v-list-item-content>
		</v-list-item>

		<v-divider class="mb-4 mt-2 opacity-70"></v-divider>
	</div>
</template>

<script>
export default {
	name: 'Section',
	components: {},
	props: {
		data: {
			type: Object,
			default: () => ({})
		},
		isAdmin: Boolean
	},
	data() {
		return {
			localData: false
		};
	},
	async created() {
		this.localData = await this.data;
	},
	computed: {},
	methods: {
		canView(localData) {
			return !localData?.adminOnly || localData?.adminOnly && this.isAdmin;
		},
		
		emitEvent(emit) {
			if(Array.isArray(emit) && emit.length > 0) {
				const eventName = emit[0];
				const eventData = emit.slice(1); // Extract all data after the event name
				this.$emit(eventName, ...eventData);
			}
		}
	},
	watch: {
		data: {
			deep: true,
			handler(newVal) {
				this.localData = newVal;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.v-list-item {
	&--link:before {
		background: none !important;
	}

	&__subtitle {
		overflow: initial;
		text-overflow: initial;
		white-space: initial;
	}
}
</style>
